export default __webpack_public_path__ + "static/media/service-01.f283dc29.png";